import { render, staticRenderFns } from "./SubscriptionTypeList.vue?vue&type=template&id=5882267a&"
import script from "./SubscriptionTypeList.vue?vue&type=script&lang=js&"
export * from "./SubscriptionTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports